// extracted by mini-css-extract-plugin
export var externalLink = "_a6-0";
export var internalLinkLabel = "_a6-1";